<template>
  <div
    class="mode1-wrap"
    :class="{
      isMobile: isMobile,
    }"
    v-if="item.isShow === 1"
    v-exposure="{ eid: `101_12_${curindex}_0`, jump_value: item.list[showStatus]?.jump }"
    :data-id="`101_12_${curindex}_0`"
  >
    <div
      class="mode1-container"
      :style="{
        backgroundImage: `url(${currentImage})`,
      }"
    >
      <div class="model1-left">
        <template v-if="!isLogin">
          <div class="model1-title">{{ $t("Datalang.newly_stay_lucky") }}</div>
          <div class="model1-desc">
            <div class="model1-tip account-tip">{{ $t("Datalang.newly_claim_register") }}</div>
            <div class="model1-tip mt10 lg">
              <span class="white">{{ $t("Datalang.newly_up_to") }}</span
              ><span class="hit" v-if="tips">{{ curCoinObj.symbol }}{{ tips }}</span>
              <span class="hit" v-if="vipData.times">{{
                formatLang($t("Datalang.newly_spins_wheel"), [vipData.times])
              }}</span>
            </div>
            <div class="model1-tip account-tip mt10">{{ $t("Datalang.newly_casino_sports") }}</div>
          </div>
          <div class="model1-footer" v-if="$utils.lang_data(lang, item.list[showStatus], 'langInfoObj')?.btnText">
            <div class="model1-btn" @click="handleClick(0)">
              {{ $utils.lang_data(lang, item.list[showStatus], "langInfoObj")?.btnText }}
            </div>
          </div>
        </template>
        <template v-else-if="!isRecharge && isLogin && rechargeTips">
          <div class="model1-title">{{ $t("Datalang.newly_newcomer") }}</div>
          <div class="model1-desc">
            <div class="model1-tip account-tip">{{ $t("Datalang.newly_extra_topup") }}</div>
            <div class="model1-tip mt10 lg">
              <span class="white">{{ $t("Datalang.newly_up_to") }}</span>
              <span class="hit" v-if="rechargeTips">{{ rechargeTips }}</span>
            </div>
            <div class="model1-tip account-tip mt10">{{ $t("Datalang.newly_bonus") }}</div>
          </div>

          <div class="model1-footer" v-if="$utils.lang_data(lang, item.list[showStatus], 'langInfoObj')?.btnText">
            <div class="model1-btn" @click="handleClick(1)">
              {{ $utils.lang_data(lang, item.list[showStatus], "langInfoObj")?.btnText }}
            </div>
          </div>
        </template>
        <template v-else-if="isRecharge && isLogin">
          <!-- 标签站位 -->
          <div class="model1-title"></div>
          <div class="model1-desc">
            <div class="model1-tip account-tip"></div>
            <div class="model1-tip mt10 lg">
              <span class="white"> </span>
              <span class="hit" v-if="rechargeTips"> </span>
            </div>
            <div class="model1-tip account-tip mt10"></div>
          </div>
          <div class="model1-footer" v-if="$utils.lang_data(lang, item.list[showStatus], 'langInfoObj')?.btnText">
            <div class="model1-btn" @click="handleClick(2)">
              {{ $utils.lang_data(lang, item.list[showStatus], "langInfoObj")?.btnText }}
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import mode1 from "@/lobby_common/mixins_views/homeModule/mode1.js";
export default {
  mixins: [mode1],
};
</script>
<style lang="scss">
.mode1-login-mode {
  position: absolute;
  bottom: 10px;
  left: 30px;
  z-index: 1;
  box-sizing: border-box;
  width: 40%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
<style lang="scss" scoped>
.bg-img {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
}
.mode1-wrap {
  position: relative;
  min-height: 445px;
  background: var(--background-203);
}
.mode1-container {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 1340px;
  height: 100%;
  padding: 0 35px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  transition: background-image 1s ease-in-out;
  .model1 {
    &-left {
      width: 450px;
    }
    &-title {
      font-size: 40px;
      font-weight: bold;
      line-height: 60px;
      text-align: center;
      color: #ffffff;
    }
    &-desc {
      margin: 20px 0;
      width: 450px;
      height: 160px;
      // background-image: linear-gradient(90deg, #0643a140 100%);
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    &-tip {
      text-align: center;
      font-size: 28px;
      .white {
        color: var(--font-color-200);
      }
      .hit {
        font-weight: bold;
        @include font-radient-account;
      }
      &.account-tip {
        color: var(--font-color-200);
        font-size: 24px;
      }
    }
    &-footer {
      display: flex;
      justify-content: center;
      align-items: center;
      .model1-btn {
        width: 340px;
        height: 52px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        @include buttonYellow;
      }
    }
  }
}
.mt10 {
  margin-top: 10px;
}
.mode1-wrap {
  &.isMobile {
    .mt10 {
      margin-top: 5px;
    }
    min-height: 180px;
    .mode1-container {
      padding: 0 10px 0 0;
      .model1-left {
        width: auto;
      }
      .model1-title {
        text-align: center;
        font-size: 16px;
        line-height: 18px;
      }
      .model1-desc {
        margin: 10px 0;
        width: 180px;
        height: 60px;
      }
      .model1-tip {
        font-size: 11px;
        &.lg {
          font-size: 12px;
        }
      }
      .model1-footer {
        justify-content: center;
        .model1-btn {
          width: 110px;
          height: 30px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
